import moment from 'moment';
import React from 'react';
import { getHolidayData } from '../../service/adminApi';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import './listof-holidays.css';
import { getS3 } from '../../utils/Download';

function HolidayList() {
    const [holidayList, setHolidayList] = React.useState([]);
    const [holidayData, setHolidayData] = React.useState({});
    const [holidayYear, setHolidayYear] = React.useState('');
    const [holidayImageUrls, setHolidayImageUrls] = React.useState({});
    let date = {
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        7: 'Sunday',
    };

    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'How Do I ?', isActive: true, path: '/HolidayList' },
        { title: 'Holiday List', isActive: false, path: '' },
    ];

    React.useEffect(() => {
        getHolidayIcons();
    }, []);

    React.useEffect(() => {
        const fetchHolidayImages = async () => {
            const urlPromises = Object.entries(holidayData).flatMap(([month, holidays]) => 
                holidays.map(async holiday => {
                    const url = holiday.image_url ? await getS3(holiday.image_url) : '/default-image-path'; // use default image if necessary
                    return [holiday.id, url];
                })
            );
            const urls = await Promise.all(urlPromises);
            setHolidayImageUrls(Object.fromEntries(urls));
        };
    
        if (Object.keys(holidayData).length > 0) {
            fetchHolidayImages();
        }
    }, [holidayData]);

    const getHolidayIcons = async () => {
        let year = new Date(new Date().getFullYear(), 0, 1);
        year = moment(year).format('YYYY-MM-DD');
        //year = '2023-01-01';

        setHolidayYear(year);
        let data = { year };
        const response = await getHolidayData(data);

        getStructureData(response.data.data);
    };

    const getStructureData = (data) => {
        let obj = {};

        for (let index = 0; index < data.length; index++) {
            let month = moment(data[index].start_date).utc().format('MMM');
            if (obj.hasOwnProperty(month)) {
                let arr = obj[month];
                let newData = data[index];
                newData['start_date'] = moment(data[index].start_date).utc().format('MMM DD, YYYY');
                newData['weekday'] = date[moment(data[index].start_date).day()];
                arr.push(newData);
                obj[month] = arr;
            } else {
                let newData = data[index];
                newData['start_date'] = moment(data[index].start_date).utc().format('MMM DD, YYYY');
                newData['weekday'] = date[moment(data[index].start_date).day()];
                obj[month] = [newData];
            }
        }
        setHolidayData(obj);
        setHolidayList(Object.keys(obj));

    };

    return (
        <div className="container-fluid mt-5">
            <div className="row justify-content-center mt-3">
                <div className="col-md-11 py-2">
                    <BreadCrumbs data={breadCrumbsData} />
                    {/*list of holidays starts here*/}
                    <h5 className="font-15 mb-2 tt-bold holidays-headerfont">Holiday List</h5>
                    {/*jan start here*/}

                    {holidayList.length > 0 ? (
                        holidayList?.map((month) => {
                            let year = moment(holidayYear).format('YYYY');
                            return (
                                <div className="row">
                                    <h5 className="font-15 tt-bold holidays-headerfont mt-4">
                                        {month}, {year}
                                    </h5>
                                    {holidayData[month].map((holiday) => {
                                        return (
                                            <div className="col-md-4 py-2">
                                                <div className=" bg-white border-0 rounded-3 p-3 d-flex justify-content-between align-items-center">
                                                    <div className="d-flex ">
                                                        <div className="align-self-center">
                                                        <img className="emoji-sty" src={holidayImageUrls[holiday.id] || '/default-image-path'} alt="icon" />
                                                        </div>
                                                        <div className="d-block ps-4">
                                                            <h5 className="bold-text holidays-head-clr">{holiday.name}</h5>
                                                            <p className="medium-text font-12 holidays-para-clr mb-0 ps-1">
                                                                {holiday.weekday}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <label className="bold-text d-flex text-center font-14 holidays-head-clr">
                                                        {holiday.start_date}
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })
                    ) : (
                        <div className="row justify-content-center  w-100">
                            <img src="/Images/nodatafound.png" alt="no-records" style={{ width: 700, height: 500 }} />
                            <span className="row justify-content-center tt-bold font-16">No Holiday Found</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default HolidayList;
